exports.components = {
  "component---src-404-index-tsx": () => import("./../../../src/404/index.tsx" /* webpackChunkName: "component---src-404-index-tsx" */),
  "component---src-api-reference-index-tsx": () => import("./../../../src/apiReference/index.tsx" /* webpackChunkName: "component---src-api-reference-index-tsx" */),
  "component---src-doc-index-tsx": () => import("./../../../src/doc/index.tsx" /* webpackChunkName: "component---src-doc-index-tsx" */),
  "component---src-search-index-tsx": () => import("./../../../src/search/index.tsx" /* webpackChunkName: "component---src-search-index-tsx" */)
}

